
import RichText from '../common/RichText.vue'

export default {
  name: 'RichText',
  components: { RichText },
  props: {
    content: {
      type: Array,
      default: () => []
    },
    parentKey: {
      type: String,
      default: ''
    }
  },
  methods: {
    getParagraphClass(type) {
      if (this.parentKey) return ''

      if (['heading', 'paragraph', 'ordered_list', 'bullet_list'].includes(type)) {
        return 'paragraph'
      }

      return ''
    },
    scrubLink(link) {
      return {
        path: link.href.replace('pages/', ''),
        hash: link.anchor
      }
    },
    spreadClasses(arr, key) {
      if (!Array.isArray(arr)) return ''

      return arr.reduce((classes, obj) => {
        classes.push(obj[key])

        return classes
      }, []).join(' ')
    },
    spreadStyles(arr) {
      if (!Array.isArray(arr)) return null

      const style = {}
      arr.forEach(item => {
        if (item.type === 'textStyle') {
          for (const key in item.attrs) {
            style[key] = item.attrs[key]
          }
        }
      })

      return style
    },
    getLinkUrl(link) {
      let url = link.attrs?.href || '#'
      if (link.attrs?.linktype === 'email') {
        url = `mailto:${url}`
      }
      return url
    }
  }
}
